import { IncomeDetailsData, PaymentDetail } from "../types";

export const calculateIncomeSummary = (
  values: IncomeDetailsData[],
  setIncomeSummary: any
) => {
  let totalAmountBeforeGst = 0;
  let totalGstAmount = 0;
  let totalPayments = 0;
  let totalOtherIncomes = 0;
  let gstPercentage =
    values?.find((income) => ["perkm", "fixed"].includes(income.incomeType))
      ?.gstPercentage || 0;

  values?.length > 0 &&
    values?.forEach((income) => {
      const amountBeforeGst = Number(income.amount) || 0;

      const mainAmountBeforeGst =
        income.incomeType === "perkm"
          ? amountBeforeGst * (income.limit || 0)
          : amountBeforeGst;

      totalAmountBeforeGst += mainAmountBeforeGst;

      if (gstPercentage) {
        const incomeGst = parseFloat(
          ((mainAmountBeforeGst * gstPercentage) / 100).toFixed(2)
        );
        totalGstAmount += incomeGst;
      }

      // Sum up payments
      totalPayments += income.paymentDetails
        .filter((payment: PaymentDetail) => !payment.deletedAt) // Filter out deleted payments
        .reduce(
          (acc: number, curr: PaymentDetail) => acc + Number(curr.paymentAmount),
          0
        );
    });

  const dividedGst = parseFloat((totalGstAmount / 2).toFixed(2));
  const sgstAmount = dividedGst;
  const cgstAmount = dividedGst;

  const totalIncome = totalAmountBeforeGst + totalGstAmount;
  const balanceAmount = totalIncome - totalPayments;

  setIncomeSummary({
    amountBeforeGst: totalAmountBeforeGst,
    totalGstAmount,
    amountAfterGst: totalIncome,
    gstPercentage,
    incomeType: values?.[0]?.incomeType || "fixed",
    sgstAmount,
    cgstAmount,
    balanceAmount,
    totalPayments,
  });
};
